import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { IWelcomeFlowUserData } from '../api'

export const prefillChangeRequest = (
  userData: IWelcomeFlowUserData,
  partnerId: string = ''
): IFormJBPHPContactChangeRequest => {
  return {
    Email: userData.Email,
    FirstName: userData.FirstName,
    LastName: userData.LastName,
    ManagerEmail: userData.ManagerEmail,
    BusinessUnit: '',
    Roles: '',
    AssignmentPeriod: '',
    EntryId: -1,
    LeadPBM: 0,
    ManagerFirstName: userData.ManagerFirstName,
    ManagerLastName: userData.ManagerLastName,
    PartnerId: partnerId,
    PartnerName: '',
    RequestAction: '',
    TicketId: -1,
    TicketStatus: 'New',
  }
}
